module.exports = __webpack_public_path__ + "img/iphoneX.7a7e3b3a.png";